/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Allow_Merge_Brief_EventsInputs */



/**
* | output |
* | --- |
* | "Allow merging of brief events" |
*
* @param {Allow_Merge_Brief_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const allow_merge_brief_events = /** @type {((inputs?: Allow_Merge_Brief_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Allow_Merge_Brief_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autoriser la fusion des événements brefs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zusammenführen kurzer Ereignisse erlauben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Consenti l'unione di eventi brevi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Разрешить объединение коротких событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Permitir la fusión de eventos breves")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("允许合并短事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("短いイベントの結合を許可")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संक्षिप्त घटनाओं के विलय की अनुमति दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Permitir a fusão de eventos breves")
	return /** @type {LocalizedString} */ ("Allow merging of brief events")
});